export var TASK_HAS_REPEATING_QUESTION_TAG_LABEL = 'has_repeat_setting';
export var TASK_REPEATING_QUESTION_TAG_LABEL = 'repeat_setting';